import React, { useState } from "react";
import { Link } from "react-router-dom";
import ClassicMenu from "../../assets/food_menus/Classic_Menu.jpeg";
import TraditionalMenu from "../../assets/food_menus/Traditional_house_dishes.jpeg";
import SaladsMenu from "../../assets/food_menus/Salads.jpeg";
import HeritageMenu from "../../assets/food_menus/Heritage_Menu.jpeg";
import DrinksDessertsMenu from "../../assets/food_menus/drinks_desserts.jpeg";

function Menusection() {
  const [tabMenu, tabActive] = useState({ a: true });

  return (
    <>
      <section className="menu-section">
        <div className="auto-container">
          <div className="title-box centered">
            <div className="subtitle">
              <span>Special selection</span>
            </div>

            <div className="pattern-image">
              <img
                src={require("../../assets/images/icons/separator.svg").default}
                alt="mySvgImage"
              />
            </div>

            <h2>Delicious Menu</h2>
          </div>

          <div className="tabs-box menu-tabs">
            <div className="buttons">
              <ul className="tab-buttons clearfix">
                <li
                  className={`tab-btn ${tabMenu.a && "active-btn"}`}
                  onClick={() => tabActive({ a: true })}
                  data-tab="#tab-1"
                >
                  <span>Classics</span>
                </li>
                <li
                  className={`tab-btn ${tabMenu.b && "active-btn"}`}
                  onClick={() => tabActive({ b: true })}
                  data-tab="#tab-2"
                >
                  <span>Burmese Street Food</span>
                </li>
                <li
                  className={`tab-btn ${tabMenu.c && "active-btn"}`}
                  onClick={() => tabActive({ c: true })}
                  data-tab="#tab-3"
                >
                  <span>Salads</span>
                </li>
                <li
                  className={`tab-btn ${tabMenu.d && "active-btn"}`}
                  onClick={() => tabActive({ d: true })}
                  data-tab="#tab-4"
                >
                  <span>Heritage Sets</span>
                </li>
                <li
                  className={`tab-btn ${tabMenu.e && "active-btn"}`}
                  onClick={() => tabActive({ e: true })}
                  data-tab="#tab-5"
                >
                  <span>Wok Kissed Greens</span>
                </li>
                <li
                  className={`tab-btn ${tabMenu.f && "active-btn"}`}
                  onClick={() => tabActive({ f: true })}
                  data-tab="#tab-6"
                >
                  <span>Drinks</span>
                </li>
                <li
                  className={`tab-btn ${tabMenu.g && "active-btn"}`}
                  onClick={() => tabActive({ g: true })}
                  data-tab="#tab-7"
                >
                  <span>Desserts</span>
                </li>
              </ul>
            </div>
            <div className="tabs-content">
              <div className={`tab ${tabMenu.a && "active-tab"}`} id="tab-1">
                <div className="text-center" style={{ marginBottom: "30px" }}>
                  <a href={ClassicMenu} target="_blank" rel="noopener noreferrer" className="theme-btn btn-style-one">
                    <span>View Full Classics Menu</span>
                  </a>
                </div>
                <div className="row clearfix">
                  <div className="menu-col col-lg-6 col-md-12 col-sm-12">
                    <div className="inner">
                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">Mont-Hinn-Ngar</Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£10.50</span>
                            </div>
                          </div>
                          <div className="text desc">
                            <Link to="#">
                              A traditional Burmese rice-noodle soup with a
                              savoury, aromatic fish-based broth, featuring a
                              variety of garnishes
                            </Link>
                          </div>
                        </div>
                      </div>

                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">
                                  Ohn-No-Khauk-Swel{" "}
                                  {/* <span className="s-info">SEASONAL</span> */}
                                </Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£10.50</span>
                            </div>
                          </div>
                          <div className="text desc">
                            <Link to="#">
                              A Burmese style egg-noodle soup known for its
                              rich, creamy coconut broth with succulent bites of
                              chicken
                            </Link>
                          </div>
                        </div>
                      </div>

                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">Nan-Gyi-Thoke</Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£9.50</span>
                            </div>
                          </div>
                          <div className="text desc">
                            <Link to="#">
                              Thick noodles tossed with chickpea powder and
                              shredded sautéed chicken, topped with fresh herbs
                              and boiled egg
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="menu-col col-lg-6 col-md-12 col-sm-12">
                    <div className="inner">
                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">
                                  Nan-Pyar-Thoke{" "}
                                  {/* <span className="s-info">NEW</span> */}
                                </Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£9.50</span>
                            </div>
                          </div>
                          <div className="text desc">
                            <Link to="#">
                              Akin to Nan-Gyi-Thoke, this dish features thick
                              flat noodles tossed in chickpea powder and
                              shredded sautéed chicken, topped with fresh herbs,
                              and boiled egg, with the flat noodles adding a
                              unique twist
                            </Link>
                          </div>
                        </div>
                      </div>

                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">Shan-Khauk-Swel</Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£9.50</span>
                            </div>
                          </div>
                          <div className="text desc">
                            <Link to="#">
                              Essence of Shan cuisine (Northeastern Burma),
                              featuring rice noodles served in a savoury sauce
                              of soybeans and spices, combined with diced
                              sautéed chicken and pickled vegetables
                            </Link>
                          </div>
                        </div>
                      </div>

                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">
                                  Kyay-Oh{" "}
                                  <span className="s-info">
                                    (Dry/Soup) (Pork/Chicken)
                                  </span>
                                </Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£12.50</span>
                            </div>
                          </div>
                          <div className="text desc">
                            <Link to="#">
                              A versatile vermicelli bowl served as either a
                              soup, or dry with the cloudy broth served
                              separately. Enriched with chicken or pork
                              meatballs, it's ideal for those preferring gentle
                              flavours over spicy or bold tastes. **If you
                              prefer not to have offal, please kindly request
                              its exclusion when ordering**
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className={`tab ${tabMenu.b && "active-tab"}`} id="tab-2">
                <div className="text-center" style={{ marginBottom: "30px" }}>
                  <a href={TraditionalMenu} target="_blank" rel="noopener noreferrer" className="theme-btn btn-style-one">
                    <span>View Full Traditional House Dishes Menu</span>
                  </a>
                </div>
                <div className="row clearfix">
                  <div className="menu-col col-lg-6 col-md-12 col-sm-12">
                    <div className="inner">
                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">
                                  Beef Curry
                                </Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£16.50</span>
                            </div>
                          </div>
                          <div className="text desc">
                            <Link to="#">
                              Tender beef slow-braised with onions, garlic,
                              ginger, freshly chopped tomatoes and traditional
                              Burmese spices, creating a rich, aromatic curry
                              full of deep, authentic flavour.
                            </Link>
                          </div>
                        </div>
                      </div>

                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">
                                  Chicken Masalar
                                </Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£15.50</span>
                            </div>
                          </div>
                          <div className="text desc">
                            <Link to="#">
                              Chicken thighs slow-cooked with onions, garlic,
                              ginger, tomatoes, and aromatic Burmese spices,
                              creating a rich, fragrant curry with bold,
                              authentic flavour, extra enhanced with a topping
                              of Ka Lar Lay masalar.
                            </Link>
                          </div>
                        </div>
                      </div>

                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">Three Layers Pork Stew</Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£16.50</span>
                            </div>
                          </div>
                          <div className="text desc">
                            <Link to="#">
                              Slow-braised pork belly with garlic, ginger, fried
                              onion, dark soya sauce, oyster sauce and
                              traditional Burmese seasonings, creating a rich,
                              savoury stew with melt-in-the-mouth layers of meat
                              and fat.
                            </Link>
                          </div>
                        </div>
                      </div>

                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">
                                  Prawn Curry
                                </Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£17.50</span>
                            </div>
                          </div>
                          <div className="text desc">
                            <Link to="#">
                              Succulent prawns cooked with fresh tomatoes,
                              garlic, onions, and traditional Burmese seasonings,
                              creating a light, tangy, and savoury curry full of
                              authentic flavour.
                            </Link>
                          </div>
                        </div>
                      </div>

                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">
                                  Duck Curry
                                </Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£17.50</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">
                                  Lamb Curry
                                </Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£16.50</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">
                                  Goat Curry
                                </Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£16.50</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="menu-col col-lg-6 col-md-12 col-sm-12">
                    <div className="inner">
                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">
                                  Fish Curry
                                </Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£16.50</span>
                            </div>
                          </div>
                          <div className="text desc">
                            <Link to="#">
                              Fresh water Burmese fish marinated with turmeric
                              and fish sauce, cooked with coriander, fresh green
                              chillies, tamarind, garlic, ginger, and
                              traditional Burmese spices, creating a fragrant,
                              tangy, and authentic home-style curry.
                            </Link>
                          </div>
                        </div>
                      </div>

                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">
                                  Aubergine Curry
                                </Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£13.50</span>
                            </div>
                          </div>
                          <div className="text desc">
                            <Link to="#">
                              Tender aubergine with fermented soybean paste,
                              garlic, ginger, and traditional Burmese seasonings,
                              creating a rich, savoury, and flavourful vegan
                              curry.
                            </Link>
                          </div>
                        </div>
                      </div>

                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">
                                  Traditional Lentil Curry
                                </Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£13.50</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">
                                  Slow-braised Pork Trotter Curry
                                </Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£17.50</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className={`tab ${tabMenu.c && "active-tab"}`} id="tab-3">
                <div className="text-center" style={{ marginBottom: "30px" }}>
                  <a href={SaladsMenu} target="_blank" rel="noopener noreferrer" className="theme-btn btn-style-one">
                    <span>View Full Salads Menu</span>
                  </a>
                </div>
                <div className="row clearfix">
                  <div className="menu-col col-lg-6 col-md-12 col-sm-12">
                    <div className="inner">
                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">La-Phet Thoke</Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£8.50</span>
                            </div>
                          </div>
                          <div className="text desc">
                            <Link to="#">
                              Earthy pickled tea leaves mixed with dried prawns
                              and double-fried legumes for a lively contrast of
                              textures and flavours
                            </Link>
                          </div>
                        </div>
                      </div>

                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">
                                  Ginn Thoke{" "}
                                  {/* <span className="s-info">SEASONAL</span> */}
                                </Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£8.50</span>
                            </div>
                          </div>
                          <div className="text desc">
                            <Link to="#">
                              Finely sliced, tender young ginger salad offering
                              a flavourful bite that also eases indigestion and
                              inflammation
                            </Link>
                          </div>
                        </div>
                      </div>

                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">Pone-Yay-Gyi Thoke</Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£6.50</span>
                            </div>
                          </div>
                          <div className="text desc">
                            <Link to="#">
                              Rich, umami depth of the fermented horse gram
                              beans combined with freshly chopped onion and
                              spices
                            </Link>
                          </div>
                        </div>
                      </div>

                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">Nga-Pi-Yay-Toh-Sa-Yar</Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£6.50</span>
                            </div>
                          </div>
                          <div className="text desc">
                            <Link to="#">
                              Features crisp crudités, including seasonal
                              vegetables, accompanied by a pungent, flavourful
                              fermented fish dip. This combination pairs
                              wonderfully with rice, Traditonal House Dishes and
                              our Heritage Sets, adding a bold, savoury touch to
                              your meal
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="menu-col col-lg-6 col-md-12 col-sm-12">
                    <div className="inner">
                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">
                                  Say-Bal-Ou-Thoke{" "}
                                  {/* <span className="s-info">NEW</span> */}
                                </Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£9.50</span>
                            </div>
                          </div>
                          <div className="text desc">
                            <Link to="#">
                              Unique, creamy texture of century eggs perfectly
                              balanced by the freshness of the tangy salad
                            </Link>
                          </div>
                        </div>
                      </div>

                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">Pazun-Chin-Thoke</Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£10.50</span>
                            </div>
                          </div>
                          <div className="text desc">
                            <Link to="#">
                              Homemade delicate rice cakes with a subtle tang,
                              made from fresh rice and whole shrimps fermented
                              together, served with a burst of vibrant herbs
                            </Link>
                          </div>
                        </div>
                      </div>

                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">Nga-Phel-Chin-Thoke</Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£10.50</span>
                            </div>
                          </div>
                          <div className="text desc">
                            <Link to="#">
                              Homemade rice cakes with a firm texture and
                              tangy-sweet flavor, made from fresh rice and
                              scraped featherback fish fermented together,
                              served with a burst of vibrant herbs
                            </Link>
                          </div>
                        </div>
                      </div>

                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">Myinn-Khwar-Ywat-Thoke</Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£7.50</span>
                            </div>
                          </div>
                          <div className="text desc">
                            <Link to="#">
                              Boasts the greenest on the menu, featuring
                              pennywort leaves complemented by the nutty, earthy
                              balance of pounded peanuts
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className={`tab ${tabMenu.d && "active-tab"}`} id="tab-4">
                <div className="text-center" style={{ marginBottom: "30px" }}>
                  <a href={HeritageMenu} target="_blank" rel="noopener noreferrer" className="theme-btn btn-style-one">
                    <span>View Full Heritage Sets Menu</span>
                  </a>
                </div>
                <div className="row clearfix">
                  <div className="menu-col col-lg-6 col-md-12 col-sm-12">
                    <div className="inner">
                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">Rangoon Set <span className="s-info">(ideal for two)</span></Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£37.50</span>
                            </div>
                          </div>
                          <div className="text desc">
                            <Link to="#">
                              Savour the heritage flavours of Rangoon with
                              Pa-Zun-Chin Thoke, your choice of house curry,
                              soup, rice, and today’s selection of fritters
                            </Link>
                          </div>
                        </div>
                      </div>

                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">Mandalay Set <span className="s-info">(ideal for two)</span></Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£35.50</span>
                            </div>
                          </div>
                          <div className="text desc">
                            <Link to="#">
                              Savour the heritage flavours of Mandalay with
                              Pone-Yay-Gyi Thoke, your choice of house curry,
                              soup, rice and Mandalay pea fritters
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="menu-col col-lg-6 col-md-12 col-sm-12">
                    <div className="inner">
                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">
                                  Royal Daung-Lan Set{" "}
                                  <span className="s-info">Ideal for four</span>
                                </Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£120.00</span>
                            </div>
                          </div>
                          <div className="text desc">
                            <Link to="#">
                              Experience a regal Burmese lacquerware feast with
                              our Royal Daung-lan Set. Comes with a starter and
                              three house curries of your choice, today’s
                              special soup, choice of stir-fried vegetables, an
                              assortment of fritters, a traditional lacquerware
                              tea leaf salad box, fermented fish dip with fresh
                              crudités (nga-pi-yay toh-sa-yar), dessert of the
                              day, and unlimited rice
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={`tab ${tabMenu.e && "active-tab"}`} id="tab-5">
                <div className="text-center" style={{ marginBottom: "30px" }}>
                  <a href={TraditionalMenu} target="_blank" rel="noopener noreferrer" className="theme-btn btn-style-one">
                    <span>View Full Menu (Wok Kissed Greens)</span>
                  </a>
                </div>
                <div className="row clearfix">
                  <div className="menu-col col-lg-6 col-md-12 col-sm-12">
                    <div className="inner">
                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">Morning Glory</Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£10.50</span>
                            </div>
                          </div>
                          {/* <div className="text desc">
                            <Link to="#">
                              Tomatoes, green bell pepper, sliced cucumber
                              onion, olives, and feta cheese.
                            </Link>
                          </div> */}
                          <div className="text desc">
                            <Link to="#">
                              Fresh morning glory stir-fried over high heat with
                              fragrant garlic and authentic Burmese fish paste,
                              creating a savoury, aromatic dish with crisp,
                              tender greens. Perfect as a side or with steamed
                              rice.
                            </Link>
                          </div>
                        </div>
                      </div>

                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">
                                  Kai Lan{" "}
                                  {/* <span className="s-info">Kai Lan</span> */}
                                </Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£10.50</span>
                            </div>
                          </div>
                          {/* <div className="text desc">
                            <Link to="#">
                              Vegetables, cheeses, ground meats, tomato sauce,
                              seasonings and spices
                            </Link>
                          </div> */}
                        </div>
                      </div>

                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">Cabbage</Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£7.50</span>
                            </div>
                          </div>
                          {/* <div className="text desc">
                            <Link to="#">
                              Typesetting industry lorem Lorem Ipsum is simply
                              dummy text of the priand.
                            </Link>
                          </div> */}
                          <div className="text desc">
                            <Link to="#">
                              Fresh cabbage stir-fried with garlic, fluffy egg,
                              and traditional Burmese seasonings, creating a
                              light, savoury dish with a soft, comforting
                              texture.
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="menu-col col-lg-6 col-md-12 col-sm-12">
                    <div className="inner">
                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">
                                  Cauliflower{" "}
                                  {/* <span className="s-info">NEW</span> */}
                                </Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£7.50</span>
                            </div>
                          </div>
                          {/* <div className="text desc">
                            <Link to="#">
                              Vegetables, cheeses, ground meats, tomato sauce,
                              seasonings and spices.
                            </Link>
                          </div> */}
                          <div className="text desc">
                            <Link to="#">
                              Fresh cauliflower stir-fried with garlic and
                              traditional Burmese seasonings, creating a light,
                              savoury dish with a tender yet crisp texture.
                            </Link>
                          </div>
                        </div>
                      </div>

                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">Beansprouts</Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£7.50</span>
                            </div>
                          </div>
                          {/* <div className="text desc">
                            <Link to="#">
                              Avocados with crab meat, red onion, crab salad
                              stuffed red bell pepper and green bell pepper.
                              Cucumber
                            </Link>
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className={`tab ${tabMenu.f && "active-tab"}`} id="tab-6">
                <div className="text-center" style={{ marginBottom: "30px" }}>
                  <a href={DrinksDessertsMenu} target="_blank" rel="noopener noreferrer" className="theme-btn btn-style-one">
                    <span>View Full Drinks & Desserts Menu</span>
                  </a>
                </div>
                <div className="row clearfix">
                  <div className="menu-col col-lg-6 col-md-12 col-sm-12">
                    <div className="inner">
                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">
                                  Fresh Lime Juice
                                </Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£4.50</span>
                            </div>
                          </div>
                          {/* <div className="text desc">
                            <Link to="#">
                              Tomatoes, green bell pepper, sliced cucumber
                              onion, olives, and feta cheese.
                            </Link>
                          </div> */}
                        </div>
                      </div>

                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">
                                  Lychee Juice
                                </Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£4.50</span>
                            </div>
                          </div>
                          {/* <div className="text desc">
                            <Link to="#">
                              Vegetables, cheeses, ground meats, tomato sauce,
                              seasonings and spices
                            </Link>
                          </div> */}
                        </div>
                      </div>

                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">
                                  Mango Juice
                                </Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£4.50</span>
                            </div>
                          </div>
                          {/* <div className="text desc">
                            <Link to="#">
                              Typesetting industry lorem Lorem Ipsum is simply
                              dummy text of the priand.
                            </Link>
                          </div> */}
                        </div>
                      </div>

                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">
                                  Orange Juice
                                </Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£4.50</span>
                            </div>
                          </div>
                          {/* <div className="text desc">
                            <Link to="#">
                              Typesetting industry lorem Lorem Ipsum is simply
                              dummy text of the priand.
                            </Link>
                          </div> */}
                        </div>
                      </div>

                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">
                                  Fanta
                                </Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£3.50</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">
                                  Water
                                </Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£2.50</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">
                                  Sparkling Water
                                </Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£3.50</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="menu-col col-lg-6 col-md-12 col-sm-12">
                    <div className="inner">
                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">
                                  Lemonade
                                </Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£3.50</span>
                            </div>
                          </div>
                          {/* <div className="text desc">
                            <Link to="#">
                              Vegetables, cheeses, ground meats, tomato sauce,
                              seasonings and spices.
                            </Link>
                          </div> */}
                        </div>
                      </div>

                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">
                                  Coke
                                </Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£3.50</span>
                            </div>
                          </div>
                          {/* <div className="text desc">
                            <Link to="#">
                              Avocados with crab meat, red onion, crab salad
                              stuffed red bell pepper and green bell pepper.
                              Cucumber
                            </Link>
                          </div> */}
                        </div>
                      </div>

                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">
                                  Diet Coke
                                </Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£3.50</span>
                            </div>
                          </div>
                          {/* <div className="text desc">
                            <Link to="#">
                              Vegetables, cheeses, ground meats, tomato sauce,
                              seasonings and spices
                            </Link>
                          </div> */}
                        </div>
                      </div>
                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">
                                  Coke Zero
                                </Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£3.50</span>
                            </div>
                          </div>
                          {/* <div className="text desc">
                            <Link to="#">
                              Vegetables, cheeses, ground meats, tomato sauce,
                              seasonings and spices
                            </Link>
                          </div> */}
                        </div>
                      </div>
                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">
                                  Sprite
                                </Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£3.50</span>
                            </div>
                          </div>
                          {/* <div className="text desc">
                            <Link to="#">
                              Vegetables, cheeses, ground meats, tomato sauce,
                              seasonings and spices
                            </Link>
                          </div> */}
                        </div>
                      </div>

                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">
                                  Myanmar Tea
                                </Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£3.50</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">
                                  Coffee
                                </Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£4.50</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">
                                  Herbal Tea
                                </Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£3.50</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className={`tab ${tabMenu.g && "active-tab"}`} id="tab-7">
                <div className="text-center" style={{ marginBottom: "30px" }}>
                  <a href={DrinksDessertsMenu} target="_blank" rel="noopener noreferrer" className="theme-btn btn-style-one">
                    <span>View Full Drinks & Desserts Menu</span>
                  </a>
                </div>
                <div className="row clearfix">
                  <div className="menu-col col-lg-6 col-md-12 col-sm-12">
                    <div className="inner">
                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">Shwe Yin Aye</Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£6.50</span>
                            </div>
                          </div>
                          {/* <div className="text desc">
                            <Link to="#">
                              Tomatoes, green bell pepper, sliced cucumber
                              onion, olives, and feta cheese.
                            </Link>
                          </div> */}
                        </div>
                      </div>

                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">
                                  Tha Gu
                                </Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£4.50</span>
                            </div>
                          </div>
                          {/* <div className="text desc">
                            <Link to="#">
                              Vegetables, cheeses, ground meats, tomato sauce,
                              seasonings and spices
                            </Link>
                          </div> */}
                        </div>
                      </div>

                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">
                                  Kyauk Kyaw (Agar Jelly)
                                </Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£4.50</span>
                            </div>
                          </div>
                          {/* <div className="text desc">
                            <Link to="#">
                              Typesetting industry lorem Lorem Ipsum is simply
                              dummy text of the priand.
                            </Link>
                          </div> */}
                        </div>
                      </div>
                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">
                                  San Yar
                                </Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£4.50</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="menu-col col-lg-6 col-md-12 col-sm-12">
                    <div className="inner">
                      <div className="dish-block">
                        <div className="inner-box">
                          <div className="title clearfix">
                            <div className="ttl clearfix">
                              <h5>
                                <Link to="#">
                                  Ice Cream
                                </Link>
                              </h5>
                            </div>
                            <div className="price">
                              <span>£4.50</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="open-timing">
            <div className="hours">
              Mon/Wed-Fri: <span className="theme_color">1-10pm</span> | Tue: <span className="theme_color">6-10pm</span> | Sat-Sun: <span className="theme_color">11am-10pm</span>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Menusection;
